const cn = {
  pageTitle: 'BabyAlpha 系列产品说明书 海外版',
  firstSecondaryTitle: '说明书适用范围',
  header: {
    image: {
      url: 'https://cdn.weilandog.com/app/image/instructionBook/three_dog_new1.jpg'
    }
  },
  scope: {
    list: [{
      type: '主体产品',
      name: 'BabyAlpha',
      model: 'WL4BACN/G1'
    }, {
      type: '配件',
      name: '充电器套装',
      model: 'WL4BACHGCN/G1'
    }, {
      type: '配件',
      name: '指尖遥控器',
      model: 'WL4BACTRLCN/G1'
    }, {
      type: '配件',
      name: '自动充电桩',
      model: 'WL4BADOCKCN/G1'
    }, {
      type: '配件',
      name: '一平米小世界',
      model: 'WL4BADIORAMACN/G1'
    }, {
      type: '配件',
      name: 'AutoBox',
      model: 'WL4BAAUTOBOXCN/G1'
    }]
  },
  termsExplanation: {
    title: '相关术语及代称说明',
    list: [{
      title: 'BabyAlpha',
      desc: 'BabyAlpha 是一款人工智能四足机器人的产品名。小白是这款机器狗的名字。下文中将以“小白”或“机器狗小白”指代BabyAlpha各型号产品。'
    }, {
      title: 'Always Alive',
      desc: 'Always Alive 指小白是一个鲜活生命智能体。小白会有自主行为和情绪。例如当小白电量不足时，会主动寻找充电桩/小世界，自主完成充电，无需人工干预，真正实现 24h 陪伴守护家人。'
    }, {
      title: 'AgentOS',
      desc: 'AgentOS 是南京蔚蓝智能科技有限公司（以下简称“蔚蓝”或“我们”）自主研发的具身智能引擎，能让小白拥有性格、爱好、学习成长和情感记忆。小白会像真实的宠物一样，始终陪伴在您身边。'
    }, {
      title: 'Touch To Go',
      desc: 'Touch To Go 是指混合现实操控技术。这种技术可以让您在蔚蓝机器狗 App 上（以下简称“ App ”）看到小白的视野。您只需用手指点击视野中的地面，小白就会自动沿着您的目标点移动。这种设计旨在为您创造一种有趣的体验，尤其在远程遥控时，这种体验更为便捷。'
    }, {
      title: 'AutoBox',
      desc: 'AutoBox 是产品名称，它不仅可以在运输中保护小白，还能通过智能识别技术让小白根据您的需求自动进出 AutoBox，为您带来了一种全新的体验。'
    }, {
      title: '大语言模型',
      desc: '大语言模型是一种人工智能技术，能理解和生成人类语言。在智能语音交互中，它可以理解您的语音输入，生成相关的文本输出，并转化为语音进行交互。'
    }, {
      title: '小宠物行为',
      desc: '小宠物行为是指小白作为一个智能体，拥有自己的日常自主行为习惯。在主人没有与小白交互的空闲时间中，小白会自己随意行走，找主人玩，或者去充电桩/小世界休息。'
    }]
  },
  babyalphaInfo: {
    title: '小白身份简介',
    list: [{
      title: '机器人种类',
      desc: '人工智能四足机器人（机器狗）'
    }, {
      title: '产品名',
      desc: 'BabyAlpha'
    }, {
      title: '品种',
      desc: '时空探险犬'
    }, {
      title: '名字',
      desc: '小白'
    }, {
      title: '出生地',
      desc: '中国·南京'
    }]
  },
  characteristic: {
    title: '产品特点和主要功能',
    list: [{
      title: '小宠物体验：',
      list: [{
        info: '展示小生命形态，包括仿生的姿态、声音、情绪表情等。'
      }, {
        info: '有自主行为，会自主充电，自主导航，真正做到 Always Alive。'
      }, {
        info: '效果：创造出极具吸引力的生动角色，呈现前所未有的交互场景，使您沉浸在动画角色走入现实世界的独特体验中，感受人工智能时代的神奇！'
      }]
    }, {
      title: '智能语音交互：',
      list: [{
        info: '强大的大语言模型提供丰富的语音交互体验，支持对话及指令。'
      }, {
        info: '支持英文对话，可作为私人家教随时练习英语。'
      }, {
        info: '创新的沉浸式聊天模式让您可以长时间专注地和小白对话，创造温馨治愈的陪伴场景。'
      }, {
        info: '效果：小白不仅可以陪伴孩子玩乐，还可以解答生活与学习中的各种问题，让孩子从小熟悉人工智能时代。'
      }]
    }, {
      title: '家庭联络员：',
      list: [{
        info: '连接 4G 蜂窝网络，支持远距离视频通话。'
      }, {
        info: '小白头部配备高清摄像头及高清液晶显示屏。'
      }, {
        info: '效果：为用户带来更有趣的视频通话体验。让用户和家人随时联络，为家庭增添了一份科技的温暖。'
      }]
    }, {
      title: '安全守护：',
      list: [{
        info: '入侵检测、异常运动检测。'
      }, {
        info: '通过多传感器融合的方式探测异常活动。'
      }, {
        info: '效果：该功能设计尤其适合单身女性、独居老年人、小孩等弱势群体独自在家等场景，让有生命的机器狗小白承载安全守护的功能。'
      }]
    }, {
      title: '图形化编程：',
      list: [{
        info: '包含动作类，功能持续更新。'
      }, {
        info: '在 App 中为小白编程，可以让小白做出更多动作组合。'
      }, {
        info: '效果：通过与小白互动，用户在玩乐中体验了编程的乐趣，锻炼了逻辑思维能力。这些技能帮助用户站在技术的前沿，迎接人工智能飞速发展的时代。'
      }]
    }, {
      title: '多功能遥控：',
      list: [{
        info: '支持 App 下的 TouchToGo遥控、虚拟手柄遥控，以及蓝牙指尖遥控器三种遥控方式。'
      }, {
        info: '效果：为用户带来多种操控乐趣。结合 4G 蜂窝网络技术，用户还能实现远距离的遥控操作。无论您是否在家中，都能随时随地享受与爱宠小白互动的乐趣。'
      }]
    }]
  },
  partName: {
    title: '部件名称',
    imageList: [{
      url: 'https://cdn.weilandog.com/app/image/instructionBook/part_name1_new.jpg'
    }, {
      url: 'https://cdn.weilandog.com/app/image/instructionBook/part_name2.jpg'
    }, {
      url: 'https://cdn.weilandog.com/app/image/instructionBook/part_name3.jpg'
    }]
  },
  package: {
    list: [{
      name: '机器狗整机',
      description: '主要产品',
      count: '1',
      unit: '台'
    }, {
      name: 'AutoBox（选配）',
      description: '可用于机器狗自主进出及收纳',
      count: '1',
      unit: '个'
    }, {
      name: '快速充电器套装',
      description: '作为配件，直接或间接为小白充电',
      count: '1',
      unit: '套'
    }, {
      name: '指尖遥控器套装',
      description: '用于视距范围内控制小白',
      count: '1',
      unit: '套'
    }, {
      name: '保修卡',
      description: '仅展示保修范围，更多保修内容请见官网《售后服务政策》',
      count: '1',
      unit: '张'
    }, {
      name: '合格证',
      description: '证明产品符合相关质量和安全标准',
      count: '1',
      unit: '张'
    }, {
      name: '个人信息保护提示卡',
      description: '关于使用产品时应注意的隐私和法律问题的提示',
      count: '1',
      unit: '张'
    }, {
      name: '隐私保护贴纸',
      description: '按需粘贴在小白头部摄像头位置，保护用户隐私',
      count: '6',
      unit: '个'
    }, {
      name: '个性化贴纸套装',
      description: '个性化装饰小白',
      count: '1',
      unit: '套'
    }, {
      name: '安全须知卡',
      description: '告知使用小白需要当心的危险物品及注意事项',
      count: '1',
      unit: '张'
    }, {
      name: '开机标准姿势挂卡',
      description: '告知小白开机前的标准姿势',
      count: '1',
      unit: '张'
    }]
  },
  downloadQRCode: {
    desc: 'App 下载二维码',
    url: 'https://cdn.weilandog.com/app/image/instructionBook/download_QRCode.jpg'
  },
  videoDirectionQRCode: {
    desc: '视频指导',
    url: 'https://cdn.weilandog.com/app/image/instructionBook/video_direction_QRCode.jpg'
  },
  weChatQRCode: {
    desc: '蔚蓝微信公众号二维码',
    url: 'https://cdn.weilandog.com/app/image/instructionBook/we_chat_QRCode.jpg'
  },
  guidelines: {
    title: '开箱指引',
    concentrateList: ['1. 适用于配AutoBox版本的产品。', '2. 小白运行的是完整的 AgentOS，因此在开机过程中需要加载大量的智能应用。这个过程可能需要您耐心等待90秒左右。在此期间，小白的眼睛屏幕会展示开机动画。当您看到小白在眨眼，并发出邀请您一同陪它玩耍的声音时，即表示小白已成功开机。'],
    list: [{
      title: 'STEP1：打开 AutoBox 包装箱',
      desc: '扫描上方二维码，下载安装蔚蓝机器狗 App，然后轻轻向上提起 AutoBox 的顶盖',
      url: 'https://cdn.weilandog.com/app/image/instructionBook/guidelines1.jpg'
    }, {
      title: 'STEP2：移除 AutoBox 周边障碍物',
      desc: '再次提醒：请务必移除 AutoBox 底部的纸质护角，并确保 AutoBox 周围没有障碍物，为小白自动走出来预留足够的空间',
      url: 'https://cdn.weilandog.com/app/image/instructionBook/guidelines2.jpg'
    }, {
      title: 'STEP3：AutoBox 内开机',
      desc: '请长按机器狗身侧的开机键3秒，听到“嘀”的一声提示音后松手，完成开机操作',
      url: 'https://cdn.weilandog.com/app/image/instructionBook/guidelines3.jpg'
    }, {
      title: 'STEP4：自动走出 AutoBox 后激活小白',
      desc: '小白将会自动站立并缓慢走出 AutoBox 活动，当眼睛屏幕出现二维码时，请使用 App 扫描，完成激活流程',
      url: 'https://cdn.weilandog.com/app/image/instructionBook/guidelines4.jpg'
    }]
  },
  activation: {
    desc: '用户可通过扫描激活二维码绑定小白，成为管理员，管理员可将小白分享给共享成员。',
    list: [{
      info: '下载蔚蓝机器狗 App 后，打开并登录账号'
    }, {
      info: '在 App 首页中点击“添加宠物”'
    }, {
      info: '扫描小白眼睛屏幕上显示的激活二维码，完成激活'
    }],
    abnormal: {
      title: '异常情况：',
      list: [{
        info: '激活二维码在开机5分钟后会自动跳出，若没有跳出，请按照 App 上的语音引导，生成激活二维码。'
      }, {
        info: '若扫描二维码激活时显示“网络设置异常，为你前往网络设置页”，请您按照以下步骤配置网络。'
      }],
      configure: {
        title: '配置网络',
        list: [{
          info: '第一步：点击“去连接”，在手机系统网络配置页中，找到以 A100 或 BabyAlpha 开头的网络，输入密码 12345678'
        }, {
          info: '第二步：返回蔚蓝机器狗 App 网络设置页，点击“配对”'
        }, {
          info: '第三步：输入您需要连接的家中 Wi-Fi 名称及密码，点击“确认”'
        }, {
          info: '第四步：30秒后请再次点击 App 首页中的“添加宠物”扫描二维码，完成激活'
        }]
      }
    }
  },
  anomalous: {
    title: '异常排除',
    list: [{
      name: '小白无法开机',
      info: '按键灯点亮后又熄灭',
      cause: '开机方法错误',
      solution: '长按开机按钮3秒，听到一声“嘀”后松手，完成开机'
    }, {
      name: '小白无法开机',
      info: '按键灯亮起迅速熄灭',
      cause: '按键操作过于频繁',
      solution: '5秒钟之后再按照说明重新开机'
    }, {
      name: '小白无法开机',
      info: '按键灯不亮/亮起后又熄灭/常亮后电量显示灯不亮',
      cause: '小白电量不足',
      solution: '在配件盒中取出充电器为小白充电约90分钟'
    }, {
      name: '小白不会从 AutoBox 中站立并走出来',
      info: '按键灯常亮，电量指示灯一颗 LED 常亮',
      cause: '小白电量不足',
      solution: '在配件盒中取出充电器为小白充电约90分钟'
    }, {
      name: '小白不会从 AutoBox 中站立并走出来',
      info: '按键灯常亮，电量指示灯显示两格电或更多',
      cause: '探测雷达被异物挡住',
      solution: '清除包装箱内及箱外附近异物，长按关机键听到“嘀”的一声松手，完成关机，然后再次开机'
    }, {
      name: '小白无法站立',
      info: '小白提示：“开机姿态不正确，请帮我把四肢摆放整齐后，重新启动吧。”',
      cause: '小白静态姿态有问题',
      solution: '将小白四肢放平，摆正姿势，重新开机'
    }]
  },
  troubleshooting: {
    title: '开箱问题及异常排除',
    list: [{
      title: '小白无法开机(按键灯点亮后又熄灭)',
      desc: '开机方法错误--长按开机按钮3秒，听到一声“嘀”后松手，完成开机'
    }, {
      title: '小白无法开机(按键灯亮起迅速熄灭)',
      desc: '按键操作过于频繁--5秒钟之后再按照说明重新开机'
    }, {
      title: '小白无法开机(按键灯不亮/亮起后又熄灭/常亮后电量显示灯不亮)',
      desc: '小白电量不足--在配件盒中取出充电器为小白充电约90分钟'
    }, {
      title: '小白不会从 AutoBox 中站立并走出来(按键灯常亮，电量指示灯一颗 LED 常亮)',
      desc: '小白电量不足--在配件盒中取出充电器为小白充电约90分钟'
    }, {
      title: '小白不会从 AutoBox 中站立并走出来(按键灯常亮，电量指示灯显示两格电或更多)',
      desc: '探测雷达被异物挡住--清除包装箱内及箱外附近异物，长按关机键听到“嘀”的一声松手，完成关机，然后再次开机'
    }, {
      title: '小白无法站立(小白提示：“开机姿态不正确， 请帮我把四肢摆放整齐后，重新启动吧。”)',
      desc: '小白静态姿态有问题--将小白四肢放平，摆正姿势，重新开机'
    }]
  },
  precautionsBeforeUse: {
    descList: [{
      desc: '在使用小白前，请例行检查以下事项，以确保使用安全。'
    }],
    list: [{
      info: '小白是否电量充足。'
    }, {
      info: '指尖遥控器是否电量充足。 '
    }, {
      info: '小白足底脚垫是否完整。 '
    }, {
      info: '小白四肢是否完整。前、后腿是否可以灵活运动、无异物卡顿。 '
    }, {
      info: '小白背部、胸部、腹部等机体是否有松散或损坏的迹象。'
    }, {
      info: '小白头部摄像头表面、传感器表面是否清洁、无异物遮挡。 '
    }, {
      info: '小白背部探测雷达周边是否清洁、无异物遮挡。 '
    }, {
      info: 'App 是否正常运行。 '
    }]
  },
  prepareBeforeUse: {
    list: [{
      info: '在每次操控前，您应当检查小白的基本情况，包含电池电量、运行状态、外观部分等。如有异常，请停止使用，并联系官方售后寻求帮助。'
    }, {
      info: '如果小白发出异响，请立即停止使用并联系官方售后以获得专业指导意见或维修检测服务。 '
    }, {
      info: '开机后充电指示灯全灭时表示电量较低，小白没有足够的动力完成您的正常操控，请您在操控前务必确认电量充足。 '
    }, {
      info: '在将您的小白借给他人使用之前，请确保其已阅读本说明书。您有责任保证新操控者的安全，请协助其学习使用小白的基本操作。请确保新操控者熟知小白的基本操作要点后，方可允许其操作。 '
    }, {
      info: '请勿两人或多人同时操控小白。'
    }, {
      info: '开机状态时，请勿触摸小白胸前外壳，以防内部电机长时间运行温度过高导致烫伤。 '
    }, {
      info: '开机状态时，请勿推拉小白四肢或搬动小白，以防夹伤双手。 '
    }, {
      info: '敬请您务必仔细阅读并遵循本说明书中的所有“注意”“警告”“请勿”“避免”等提示。'
    }]
  },
  bootPre: {
    title: '开机前置条件',
    list: [{
      title: '地面坚硬且平整',
      desc: '地面受力不会有肉眼可见的凹陷，避免在凹凸不平的地面或过软的地毯上启动'
    }, {
      title: '地面无明显异物',
      desc: '小白腿部及腹部接触的地面上无明显异物或凸起，避免纸皮、儿童玩具等物品影响小白静态姿态'
    }, {
      title: '小腿收紧至结构件限位',
      desc: '允许偏差 18° 以内，使小白的小腿和大腿贴紧接触'
    }, {
      title: '髋关节执行器角度要求',
      desc: '小白髋关节和大腿角度允许偏差 18° 以内，调节小白的大腿和髋关节角度，使得足底和膝关节都紧贴地面'
    }]
  },
  bootPrerequisites: {
    url: 'https://cdn.weilandog.com/app/image/instructionBook/boot_prerequisites.jpg',
    imageDesc: '开机前请确保小白处于上图所示的开机标准姿势'
  },
  buttonPosition: {
    url: 'https://cdn.weilandog.com/app/image/instructionBook/button_position.jpg'
  },
  bootMode: {
    titleText: '请按照以下步骤操作：',
    concentrate: '小白运行的是完整的 AgentOS，因此在开机过程中需要加载大量的智能应用。这个过程可能需要您耐心等待90秒左右。在此期间，小白的眼睛屏幕会展示开机动画。当您看到小白在眨眼，并发出邀请您一同陪它玩耍的声音时，即表示小白已成功开机。',
    method: '请长按开机键3秒，听到“嘀”的一声提示音后松手，完成开机操作。同时，您会看到按键灯亮起，同时电量指示亮起依次闪烁，并显示当前电量。'
  },
  shutdownMethod: {
    titleText: '为了确保您的小白在使用过程中能够灵活、精确地响应您的关机指令，小白具备如下两种关机方案。请在小白完全停止运动并安全趴下后，按照以下步骤关机。',
    concentrate: '请勿在小白运动或站立时关闭电源。一旦触发关机，小白将立即失去动力，可能导致人体受伤或物品损坏。'
  },
  standardShutdown: {
    list: [{
      info: '请长按开机按钮3～5秒，您将听到一声长鸣的“嘀”声'
    }, {
      info: '请在“嘀”声后松手，所有指示灯熄灭后，小白将自动关机'
    }]
  },
  forceShutdown: {
    concentrate: '此操作仅在无法完成标准关机时使用。',
    list: [{
      info: '请长按开机按钮超过6秒'
    }, {
      info: '请在所有指示灯熄灭后松手，小白将强制关机'
    }]
  },
  accidentallyTouched: {
    list: [{
      operate: '开机误触',
      condition: '短按开机按钮，未听到“嘀”声就松手',
      manifestation: '指示灯点亮后熄灭，小白不会开机',
      interpretation: '保护机制，防止意外开机',
      solution: '重新按照标准开机步骤操作'
    }, {
      operate: '关机误触',
      condition: '长按关机按钮时间不够长，未达到标准关机要求',
      manifestation: '无特殊声音或灯光反馈，小白继续正常运行',
      interpretation: '保护机制，防止意外关机',
      solution: '重新按照标准关机步骤操作'
    }]
  },
  chargingInstructions: {
    title: '充电说明',
    desc: '小白的三种充电方式各具特色，为您提供了灵活多样的选择，以适应不同的使用场景和个人喜好。下面是对这三种充电方式的描述。',
    smallWorldCharging: {
      title: '小世界充电：',
      descList: [{
        desc: '小世界是小白温馨精致的小窝，包括一块圆形地毯和一个实木小房子。小房子内部配备自动充电装置，让小白在其中休息的同时完成充电。'
      }, {
        desc: '小白具备先进的视觉与定位系统，能够精准地识别小世界在家中的位置。电量过低时，小白会自动回到小世界进行充电。'
      }],
      url: 'https://cdn.weilandog.com/app/image/instructionBook/small_world4_new.jpg',
      imageDesc: '小世界充电'
    },
    stationCharging: {
      title: '充电桩充电：',
      descList: [{
        desc: '自动充电桩采用磁吸组装方式。用户可以轻松组装，无需使用工具或专业技术。'
      }, {
        desc: '小白具备先进的视觉与定位系统，能够精准地识别充电桩在家中的位置。电量过低时，小白会自动回到充电桩进行充电。'
      }],
      url: 'https://cdn.weilandog.com/app/image/instructionBook/station_charging.jpg',
      imageDesc: '充电桩充电'
    },
    chargerChagring: {
      title: '充电器直充：',
      descList: [{
        desc: '小白还配备了一个 USB Type-C 接口，为您提供了直接充电的便捷方式。这种直充方式尤其适用于小白电量耗尽且无法自行移动的情况。直充在所有充电方式中充电效率最高，易于操作。不论您在何种环境，只要使用蔚蓝提供的充电器套装，都可以快速为小白补充能量，确保其持续高效运行。'
      }],
      url: 'https://cdn.weilandog.com/app/image/instructionBook/charger_charging.jpg',
      imageDesc: '充电器直充'
    }
  },
  batteryIndicator: {
    title: '通过指示灯了解充电和使用情况',
    urlList: [{
      url: 'https://cdn.weilandog.com/app/image/instructionBook/battery_indicator1.jpg'
    }, {
      url: 'https://cdn.weilandog.com/app/image/instructionBook/battery_indicator2.jpg'
    }]
  },
  indicatorSignificance: {
    title: '指示灯意义',
    list: [{
      title: '白色电量指示灯：',
      desc: '用于展示当前电量及充电时的充电进度。'
    }, {
      title: '双色充电指示灯：',
      desc: '用于指示充电状态，充电中、充满、放电。'
    }],
    concentrateList: ['请您根据以下双色充电指示灯的颜色来判断小白的充电状态。', '当小白在充电时，指示灯显示为黄色；', '当充电完成时，指示灯变为白色；', '当拔掉充电器，小白在正常运行时，指示灯熄灭。']
  },
  runningLight: {
    list: [{
      electricity: 'C≥82%',
      L1: '亮',
      L2: '亮',
      L3: '亮',
      L4: '亮',
      color: '灭'
    }, {
      electricity: '61%≤C＜82%',
      L1: '亮',
      L2: '亮',
      L3: '亮',
      L4: '灭',
      color: '灭'
    }, {
      electricity: '37%≤C＜61%',
      L1: '亮',
      L2: '亮',
      L3: '灭',
      L4: '灭',
      color: '灭'
    }, {
      electricity: '18%≤C＜37%',
      L1: '亮',
      L2: '灭',
      L3: '灭',
      L4: '灭',
      color: '灭'
    }, {
      electricity: '7%≤C＜18%',
      L1: '1.5Hz 闪烁',
      L2: '灭',
      L3: '灭',
      L4: '灭',
      color: '灭'
    }, {
      electricity: 'C<7%',
      L1: '灭',
      L2: '灭',
      L3: '灭',
      L4: '灭',
      color: '灭'
    }]
  },
  chargeLight: {
    list: [{
      electricity: 'C≥90%',
      L1: '亮',
      L2: '亮',
      L3: '亮',
      L4: '亮',
      color: '亮白色'
    }, {
      electricity: '75%≤C＜90',
      L1: '亮',
      L2: '亮',
      L3: '亮',
      L4: '1.5Hz 闪烁',
      color: '亮黄色'
    }, {
      electricity: '50%≤C＜75%',
      L1: '亮',
      L2: '亮',
      L3: '1.5Hz 闪烁',
      L4: '灭',
      color: '亮黄色'
    }, {
      electricity: '25%≤C＜50%',
      L1: '亮',
      L2: '1.5Hz 闪烁',
      L3: '灭',
      L4: '灭',
      color: '亮黄色'
    }, {
      electricity: 'C＜25%',
      L1: '1.5Hz 闪烁',
      L2: '灭',
      L3: '灭',
      L4: '灭',
      color: '亮黄色'
    }]
  },
  light: {
    concentrate: '小白配备了 4 颗电量指示灯，可向您展示剩余电量。电量被分为 4 等份，这样您可以快速查看大致的剩余电量。此外，小白还配有自动充电桩/小世界，当电量低时，小白会自行走去自动充电桩/小世界完成充电。'
  },
  checkPowerMethod: {
    title: '更多查询电量的方法',
    list: [{
      title: '开机状态下通过 LED 指示灯查询电量：',
      desc: '在小白开机状态下，设备配备的四颗 LED 灯会向您展示当前的剩余电量，直观显示电量情况。'
    }, {
      title: '开机状态下通过语音查询电量：',
      desc: '您可以在小白开机时，通过语音指令查询电量。比如，您可以说“小白小白，当前电量是多少？”，小白会以语音的形式回复精确的电量信息。'
    }, {
      title: '通过 App 查询电量：',
      desc: '在小白开机状态下，您还可以在 App 的宠物首页中查询小白的剩余电量。'
    }]
  },
  powerMethodComparison: {
    list: [{
      method: '电量指示灯（开机状态）',
      advantage: '直观显示，即时了解电量状态。',
      inferior: '提供的电量信息不够精确。'
    }, {
      method: '语音查询（开机状态）',
      advantage: '方便快捷，适合忙碌或手部操作不便的情况。',
      inferior: '语音识别需准确。'
    }, {
      method: 'App 查询（开机状态）',
      advantage: '提供精确的电量信息，支持远程查询。',
      inferior: '需要打开 App 查看。'
    }]
  },
  emergencyStopSwitch: {
    url: 'https://cdn.weilandog.com/app/image/instructionBook/emergency_stop_switch.jpg',
    effect: {
      title: '急停开关的作用',
      list: [{
        label: '保护功能：',
        desc: '当小白出现不可控情况时，急停开关能立即触发保护机制，使小白停止所有动作。为用户提供了一键式的安全控制手段，确保了用户操作的可靠性和安全性。'
      }]
    },
    operate: {
      title: '急停开关的操作',
      list: [{
        label: '操作方式：',
        desc: '遇到紧急情况时，用力按下急停开关。'
      }, {
        label: '效果：',
        desc: '小白会缓慢失去动力，最终趴在地上。'
      }]
    },
    recovery: {
      list: [{
        method: '通过 App 解除限制',
        desc: '在 App 中进入遥控界面，点击站立，即可解除急停状态。'
      }, {
        method: '通过指尖遥控器解除限制',
        desc: '按下指尖遥控器上的站立按钮，使小白重新站立。'
      }, {
        method: '通过语音指令解除限制',
        desc: '唤醒小白后，对小白说“站起来”，使小白重新站立。'
      }, {
        method: '重新启动小白解除限制',
        desc: '重新启动小白，可以恢复正常的运动能力。'
      }]
    }
  },
  remoteControl: {
    button: {
      url: 'https://cdn.weilandog.com/app/image/instructionBook/remote_control_button.jpg'
    },
    pairingMethod: {
      title: '第一次使用时配对方法',
      list: [{
        title: 'STEP1: ',
        desc: '小白和指尖遥控器保持 1m 以内的距离',
        url: 'https://cdn.weilandog.com/app/image/instructionBook/pairing1.jpg'
      }, {
        title: 'STEP2: ',
        desc: '按住 M 按键不松手，然后拨动开关，打开遥控器',
        url: 'https://cdn.weilandog.com/app/image/instructionBook/pairing2.jpg'
      }, {
        title: 'STEP3: ',
        desc: '蓝色 LED 灯由快闪变为常亮，表示连接成功',
        url: 'https://cdn.weilandog.com/app/image/instructionBook/pairing3.jpg'
      }]
    },
    parameter: {
      concentrate: '指尖遥控器有效控制范围在 5m 内，空旷区域控制范围可达 10m。如果周围有人在移动或者有金属障碍物，会严重影响信号传输，遥控器可能会出现断线的情况。当指尖遥控器与小白的距离满足最小通讯范围后，指尖遥控器自动回连到小白，恢复通讯。',
      list: [{
        category: '产品名称',
        info: '指尖遥控器'
      }, {
        category: '充电时间',
        info: '1小时 (充电电流≥500mA)'
      }, {
        category: '兼容性',
        info: '兼容BabyAlpha系列'
      }, {
        category: '产品净重',
        info: '38g'
      }, {
        category: '遥控器型号',
        info: 'WL4BACTRLCN/G1'
      }, {
        category: '充电接口',
        info: 'Micro-USB'
      }, {
        category: '工作距离',
        info: '无障碍物情况下，约10m通讯距离'
      }, {
        category: '续航时间',
        info: '满电情况下, 持续使用时间约5小时'
      }, {
        category: '产品尺寸',
        info: '73.6×41×71mm (长×宽×高)'
      }]
    }
  },
  chargeStation: {
    assemble: {
      title: '如何安装自动充电桩',
      list: [{
        title: 'STEP1: ',
        url: 'https://cdn.weilandog.com/app/image/instructionBook/assemble_station1.jpg',
        imageDesc: '磁吸插入充电桩主体'
      }, {
        title: 'STEP2: ',
        url: 'https://cdn.weilandog.com/app/image/instructionBook/assemble_station2.jpg',
        imageDesc: '磁吸插入充电盘主体'
      }, {
        title: 'STEP3: ',
        url: 'https://cdn.weilandog.com/app/image/instructionBook/assemble_station3.jpg',
        imageDesc: '请勿在充电桩前1.5m，左、右0.5m范围内放置障碍物，且请避免阳光直射充电桩'
      }]
    },
    use: {
      title: '如何使用自动充电桩',
      list: [{
        title: '让小白定位充电桩',
        descList: [{
          desc: '小白具备自主识别充电桩的能力。您只需在安装好充电桩后，点击 App 首页中的“设置充电地点”，遥控小白走到充电桩正前方。它就会在家庭空间中定位充电桩的位置。'
        }, {
          desc: '若出现小白无法完成自主充电的情况，请您重复此流程，让小白重新获取定位。'
        }],
        url: 'https://cdn.weilandog.com/app/image/instructionBook/assemble_station_use1.jpg'
      }, {
        title: '让小白去充电桩充电',
        descList: [{
          desc: '当小白电量过低时，它会自行走到充电桩处，趴到充电盘上开始充电。充电至适当电量后，它会自行离开，继续探索家中环境或陪伴主人。'
        }, {
          desc: '您也可以对小白说“去充电”，它也会自行去寻找充电桩充电。'
        }],
        url: 'https://cdn.weilandog.com/app/image/instructionBook/assemble_station_use2.jpg'
      }],
      concentrateList: ['1. 开启“守卫”功能前，请提前让小白定位好充电桩。开启“守卫”功能后，小白会趴在充电桩位置为您看家护卫。', '2. 小白通过建图的方式来了解其所在的物理世界。如果小白在建图过程中被打断，或者在建好图后被移动，小白可能会丢失自己的位置，从而需要花费更多的时间重新建图，寻找充电桩。因此，建议您在小白开机状态下避免移动它，避免夹伤双手，并确保小白正常运行。']
    },
    attention: {
      list: [{
        name: '使用前请检查充电桩固定的可靠性。',
        cause: '防止固定不可靠，造成小朋友或宠物碰倒充电桩，造成危险。',
        mark: '如有需要，您可使用充电桩内附赠的辅助胶黏贴，帮助固定充电桩。'
      }, {
        name: '使用前请将充电盘上的保护膜撕掉。',
        cause: '保护膜具有绝缘作用，为了防止运输中刮伤金属极片。',
        mark: '请撕掉保护膜后再使用。'
      }, {
        name: '请勿用导电材料连接充电盘的两个极片。',
        cause: '如果将充电盘的金属极片短接在一起，会触发电路保护，瞬间可能会出现尖端放电现象。',
        mark: '这种现象对人体无害。然而，为了设备的正常运行和使用寿命，我们仍建议您避免将金属极片短接在一起。'
      }, {
        name: '请勿将充电桩放在阳光直射的地方。',
        cause: '小白寻找充电桩依赖于多传感器融合定位，其中视觉部分是重要的一环。强光可能会影响视觉定位，从而影响自动回充的稳定性。',
        mark: '长时间的阳光直射可能会影响产品的综合寿命。为了确保小白和充电桩的正常运行和使用寿命，我们建议您在阴凉处使用充电桩。'
      }]
    }
  },
  smallWorld: {
    assemble: {
      title: '如何装配小世界',
      concentrate: '请保证充电桩前1.5m范围内无障碍物，否则会影响小白充电。',
      list: [{
        title: 'STEP1: ',
        desc: '首先请将地毯平放于合适的位置，将小房子轻轻放在地毯上',
        url: 'https://cdn.weilandog.com/app/image/instructionBook/small_world1_new.jpg'
      }, {
        title: 'STEP2: ',
        desc: '请将充电盘组件插入到小房子内的磁吸固定孔',
        url: 'https://cdn.weilandog.com/app/image/instructionBook/small_world2_new.jpg'
      }, {
        title: 'STEP3: ',
        desc: '请勿在小世界前1.5m，左、右0.5m范围内放置障碍物',
        url: 'https://cdn.weilandog.com/app/image/instructionBook/small_world3_new.jpg'
      }, {
        title: 'STEP4: ',
        desc: '请取出充电器，接通电源后，将另一端接口插入小世界',
        url: 'https://cdn.weilandog.com/app/image/instructionBook/small_world4_new.jpg'
      }]
    },
    use: {
      title: '小世界的充电方式：',
      list: [{
        title: '让小白定位小世界',
        descList: [{
          desc: '小白具备自主识别小世界的能力。您只需在安装好小世界后，点击 App 首页中的“设置充电地点”，遥控小白走到小世界正前方。它就会在家庭空间中定位小世界的位置。'
        }, {
          desc: '若出现小白无法完成自主充电的情况，请您重复此流程，让小白重新获取定位。'
        }]
      }, {
        title: '让小白去小世界充电',
        descList: [{
          desc: '当小白电量过低时，它会自行走到小世界处，趴到充电盘上开始充电。充电至适当电量后，它会自行离开，继续探索家中环境或陪伴主人。'
        }, {
          desc: '您也可以对小白说“去充电”，它也会自行去寻找小世界充电。'
        }]
      }],
      concentrateList: ['1. 开启“守卫”功能前，请提前让小白定位好小世界。开启“守卫”功能后，小白会趴在小世界位置为您看家护卫。', '2. 小白通过建图的方式来了解其所在的物理世界。如果小白在建图过程中被打断，或者在建好图后被移动，小白可能会丢失自己的位置，从而需要花费更多的时间重新建图，寻找小世界。因此，建议您在小白开机状态下避免移动它，避免夹伤双手，并确保小白正常运行。']
    },
    attention: {
      list: [{
        name: '使用前请将充电盘上的保护膜撕掉',
        cause: '保护膜具有绝缘作用，为了防止运输中刮伤金属极片。',
        mark: '请撕掉保护膜后再使用。'
      }, {
        name: '请勿用导电材料连接充电盘的两个极片',
        cause: '将充电盘的金属极片短接在一起会触发电路保护，瞬间会出现尖端放电现象。',
        mark: '小世界采用直流电设计，电压不超过30V。即使出现尖端放电现象，也不会对用户造成伤害。然而，为了设备的正常运行和使用寿命，我们仍建议您避免将金属极片短接在一起。'
      }, {
        name: '请勿将小世界放在阳光直射的地方',
        cause: '小白寻找小世界依靠多传感器融合定位，其中视觉部分为其中重要一环，强光会影响视觉定位，影响自动回充稳定性',
        mark: '小世界采用植物纤维和实木制成，长时间的阳光直射可能会影响产品的综合寿命。为了确保小白和小世界的正常运行和使用寿命，我们建议您在阴凉处使用充电桩。'
      }]
    }
  },
  wireCharge: {
    title: '线充使用说明',
    assemble: {
      title: '如何使用线充',
      concentrateList: ['1. 开启“守卫”功能前，请提前让小白定位好线充位置。开启“守卫”功能后，小白会趴在线充位置为您看家护卫。', '2. 小白通过建图的方式来了解其所在的物理世界。如果小白在建图过程中被打断，或者在建好图后被移动，小白可能会丢失自己的位置，从而需要花费更多的时间重新建图，寻找线充位置。因此，建议您在小白开机状态下避免移动它，避免夹伤双手，并确保小白正常运行。'],
      list: [{
        title: '让小白定位线充位置',
        descList: [{
          desc: '小白具备自主定位线充位置的能力。点击 App 首页中的“设置充电地点”，遥控小白走到方便充电的线充位置，它就会在家庭空间中定位线充位置。'
        }, {
          desc: '若出现小白无法找到充电位置的情况，请您重复此流程，让小白重新获取定位。'
        }]
      }, {
        title: '让小白去线充位置充电',
        descList: [{
          desc: '当小白电量过低时，它会自行走到线充位置，等待您为它插上充电线。'
        }, {
          desc: '您也可以对小白说“去充电”，它也会自行去到线充位置，等待您为它插上充电线。'
        }, {
          desc: '线充过程中，小白不能站起完成语音指令和遥控动作。'
        }]
      }]
    }
  },
  agents: {
    declaration: '声明：小白在语音交互中输出的内容是基于人工智能算法所依赖的有限数据，并不代表本公司立场，本公司对该输出内容的真实性、准确性和完整性不作任何保证。',
    connect: {
      title: '网络设置',
      app: {
        title: 'App 中连接机器狗热点',
        desc: 'App 默认会自动连接机器狗热点，若没有自动连接成功，请您按照如下步骤操作。',
        list: [{
          info: '确认机器狗已激活，并处于开机状态'
        }, {
          info: '若您有多条机器狗，请在 App 首页左上角“宠物”中“切换宠物”中选中目标机器狗'
        }, {
          info: '点击 App 首页“配对”按钮，App 将连接到机器狗热点'
        }],
        anomaly: {
          title: '异常情况：',
          desc: '若您点击“配对”按钮后，没有成功配对，请您按照以下步骤手动连接机器狗热点。',
          list: [{
            info: '首页右上角通用=>Wi-Fi与安全=>复制密码'
          }, {
            info: '手机网络设置中选择机器狗 Wi-Fi（A100 或 BabyAlpha 开头），粘贴密码，连接上机器狗热点'
          }]
        }
      },
      dogSetting: {
        title: 'App 中为机器狗配置Wi-Fi',
        list: [{
          info: '确认 App 已连接到机器狗热点（ A100 或 BabyAlpha 开头）'
        }, {
          info: '点击 App 首页的“网络连接”，进入网络配置页面'
        }, {
          info: '选择目标 Wi-Fi，输入密码后，点击“确定”，设置网络成功'
        }],
        anomaly: {
          title: '异常情况：',
          desc: '设置过程中由于扫描Wi-Fi列表可能导致手机与机器狗热点连接断开，会提示“网络配置完成，稍后检查连接”。请您重新连接机器狗热点并再次配置Wi-Fi。'
        }
      },
      fourG: {
        title: '使用机器狗4G网络',
        list: [{
          info: '若您没有在 App 中匹配宠物，默认使用机器狗的4G网络。推荐您匹配宠物后为宠物配置 Wi-Fi。'
        }, {
          info: '若机器狗连接的 Wi-Fi 信号弱，您可在 App 首页的网络连接中切换 4G，使用机器狗的 4G 流量。'
        }]
      },
      concentrateList: ['1. 机器狗的 4G 网络：您可限时每月免费使用 10G 流量。您可在 App 首页=>通用=>流量查询中查看已用流量，超出后会限制使用。', '2. 机器狗的远程时长：您可限时每月免费使用 800 分钟远程时长，用于视频通话和 App 远程遥控。您可在视频通话界面查询已用时长，超出后会限制使用。'],
      changeNetwork: {
        title: '网络切换',
        list: [{
          title: 'Wi-Fi 切换 4G',
          list: [{
            info: '若机器狗连接的 Wi-Fi 信号弱，您可点击 App 宠物页面中的“切换4G”，使用机器狗的4G流量。'
          }]
        }, {
          title: '4G切换Wi-Fi',
          list: [{
            info: '若您想将机器狗的 4G 网络切换回 Wi-Fi，您可点击 App 宠物页面中的“切换 Wi-Fi”。若您想使用上次已连接成功的 Wi-Fi，请点击“一键连接”。若您想连接新的 Wi-Fi，请在“其他网络”中选择目标 Wi-Fi 及密码。'
          }]
        }, {
          title: '切换其他Wi-Fi',
          list: [{
            info: '若您想为机器狗连接新的 Wi-Fi，您可点击 App 宠物页面中的“宠物 Wi-Fi 在线”，在“其他网络”中选择目标 Wi-Fi，并输入密码。'
          }]
        }]
      }
    },
    voice: {
      title: '如何进行语音交互',
      list: [{
        info: '小白搭载了先进、强大的大语言模型，支持中英文双语。您可以通过自然语言和小白进行对话交互，体验前所未有的人工智能时代。'
      }, {
        info: '您也可以给小白简单的动作指令，支持的指令如下：'
      }, {
        info: '向前/后/左/右走、坐下、趴下、站立/站起来、跳舞、转圈、鞠躬/敬礼、俯卧撑、握手、踢、撒尿、拉屎、放个屁、摇尾巴、抖一抖、玩耍、伸懒腰、匍匐前进、击掌、挥手、叫一声、凶一个、起床、放大招/绝招、别动/不要动、看着我、休息、让开、睡觉、回去、充电、走开、巡逻'
      }],
      instruction: {
        desc: '除了常规动作指令，您还可以要求小白完成以下指令。',
        list: [{
          info: '视频通话，您可以和小白说“打电话”、“接电话”、“挂电话”。（详见“如何进行视频通话”章节）'
        }, {
          info: '播放音乐，您可以和小白说“放音乐”、“放一首歌”、“下一首”等。'
        }, {
          info: '查询电量，您可以和小白说“电量多少”、“现在有多少电”等。'
        }, {
          info: '查询音量，您可以和小白说“音量多少”、“当前音量”等。'
        }, {
          info: '调整音量，您可以和小白说“音量调到最大”、“音量调到80”、“音量调小”等。'
        }, {
          info: '查询天气，您可以和小白说“天气怎么样”等。'
        }]
      }
    },
    chatMode: {
      title: '语音交互',
      desc: '小白的强大远超您的想象，您可以在和小白交流的过程中发现更多惊喜，探索更多适合您的专属功能！',
      list: [{
        desc: '1. 您可以通过叫“小白小白”唤醒它，即可开启连续对话。超过18秒未进行交互，需要再次唤醒。',
        url: 'https://cdn.weilandog.com/app/image/instructionBook/chat_mode1_new.jpg'
      }, {
        desc: '2. 小白会抬头认真听你说话。建议您在安静的环境中与小白进行语音对话，嘈杂的环境会干扰小白的语音识别。',
        url: 'https://cdn.weilandog.com/app/image/instructionBook/chat_mode2.jpg'
      }, {
        desc: '3. 小白的反应速度在500毫秒以内。如果出现卡顿情况，可能是由于网络延迟导致的。',
        url: 'https://cdn.weilandog.com/app/image/instructionBook/chat_mode3.jpg'
      }, {
        desc: '4. 小白会摇摆着身体回答您的问题。小白的知识库很丰富，可以帮您解答各种问题。英语对话也很拿手。',
        url: 'https://cdn.weilandog.com/app/image/instructionBook/chat_mode4.jpg'
      }, {
        desc: '5. 小白现在一次只能完成一个指令。小白的指令库会持续升级，您会在和小白的相处中发现更多乐趣。',
        url: 'https://cdn.weilandog.com/app/image/instructionBook/instruction_mode2.jpg'
      }, {
        desc: '6. 摸摸小白的后脑勺可退出语音交互。小白会在空闲时间里自己在家中探索，找主人玩，或者去充电桩/小世界休息。',
        url: 'https://cdn.weilandog.com/app/image/instructionBook/instruction_mode4.jpg'
      }]
    },
    immerseChat: {
      title: '沉浸式聊天',
      desc: '沉浸式聊天下，您可以专注地长时间和小白进行中英文对话。期间，小白不会随意走动，会认真陪伴您。',
      list: [{
        desc: '1. 您可通过对小白说“沉浸式聊天”或在 App 的蔚蓝实验室中开启此模式，开始与小白专注的聊天时间。',
        url: 'https://cdn.weilandog.com/app/image/instructionBook/immerse_chat1.jpg'
      }, {
        desc: '2. 触摸小白的后脑勺，可以进入安静的治愈陪伴时间。',
        url: 'https://cdn.weilandog.com/app/image/instructionBook/immerse_chat2.jpg'
      }, {
        desc: '3. 您可通过触摸小白的下巴唤醒小白，继续聊天。',
        url: 'https://cdn.weilandog.com/app/image/instructionBook/immerse_chat3.jpg'
      }, {
        desc: '4. 您可通过对小白说“退出沉浸式聊天”或在 App 中关闭此模式。',
        url: 'https://cdn.weilandog.com/app/image/instructionBook/immerse_chat4.jpg'
      }]
    },
    // instructionMode: {
    //   title: '指令模式',
    //   use: {
    //     desc: '指令模式下，小白可以完成聊天模式中的全部指令。除此之外，它还可以完成以下语音指令：',
    //     descList: [{
    //       desc: '向左/右/后转、向左/右/前/后走、转圈、踢球、呼叫、叫、凶人、玩耍、起床、干活、吃早饭、放大招/绝招，点头、摇头、闭眼、睁眼、放屁、抖一抖、伸懒腰、打哈欠、匍匐前进、击掌、挥手、等一等/别捣乱'
    //     }, {
    //       desc: '更多动作即将上线。'
    //     }],
    //     instruction: {
    //       desc: '除了常规动作指令，您还可以在指令模式下，要求小白完成以下指令。',
    //       list: [{
    //         info: '视频通话，您可以和小白说“打电话”、“接电话”、“挂电话”。（详见“如何进行视频通话”章节）'
    //       }, {
    //         info: '播放音乐，您可以和小白说“放音乐”、“放一首歌”等。'
    //       }, {
    //         info: '查询音量，您可以和小白说“音量多少”、“当前音量”等。'
    //       }, {
    //         info: '调整音量，您可以和小白说“音量调到最大”、“音量调到80”、“音量调小”等。'
    //       }, {
    //         info: '调整屏幕亮度，您可以和小白说“亮度调到最大”、“亮度调低”等。'
    //       }, {
    //         info: '查询天气，您可以和小白说“天气怎么样”等。'
    //       }]
    //     }
    //   },
    //   list: [{
    //     desc: '1. 您可通过对小白说“指令模式”，或者触摸小白的下巴，自由切换聊天模式和指令模式。',
    //     url: 'https://cdn.weilandog.com/app/image/instructionBook/instruction_mode1.jpg'
    //   }, {
    //     desc: '2. 小白现在一次只能完成一个指令。小白的指令库会持续升级，您会在和小白的相处中发现更多乐趣。',
    //     url: 'https://cdn.weilandog.com/app/image/instructionBook/instruction_mode2.jpg'
    //   }, {
    //     desc: '3. 在指令模式下，小白还可以拨打电话、播放音乐、查询电量、调节音量等。',
    //     url: 'https://cdn.weilandog.com/app/image/instructionBook/instruction_mode3_new.jpg'
    //   }, {
    //     desc: '4. 摸摸小白的后脑勺可退出语音交互。小白会在空闲时间里进行小宠物行为，自己在家中随意行走，找主人玩，或者去充电桩/小世界休息。',
    //     url: 'https://cdn.weilandog.com/app/image/instructionBook/instruction_mode4.jpg'
    //   }]
    // },
    enPartner: {
      title: '英语语伴',
      desc: '英语语伴模式下，小白会全程使用英语，通过聊天、讲故事、做游戏等寓教于乐的方式激发孩子开口对话的兴趣，为孩子创造纯正的英语交流环境，打破填鸭式传统英语学习，使学习更轻松有趣。',
      list: [{
        desc: '1. 您可通过唤醒小白后，对小白说“英语语伴”或者在 App 的蔚蓝实验室中打开此功能。',
        url: 'https://cdn.weilandog.com/app/image/instructionBook/en_partner1.jpg'
      }, {
        desc: '2. 首次开启时，请在 App 中输入孩子的基本信息，有助于小白了解孩子，根据喜好引导对话。此信息可随时修改。',
        url: 'https://cdn.weilandog.com/app/image/instructionBook/en_partner2.jpg'
      }, {
        desc: '3. 开启后，小白会根据孩子的英语水平匹配相应词汇量，引导孩子进行英语对话，帮助孩子练习听力和口语。',
        url: 'https://cdn.weilandog.com/app/image/instructionBook/en_partner3.jpg'
      }, {
        desc: '4. 您可通过对小白说“退出英语语伴”，或者在 App 中关闭此功能。',
        url: 'https://cdn.weilandog.com/app/image/instructionBook/en_partner4.jpg'
      }]
    },
    // changeMode: {
    //   title: '切换语音模式',
    //   list: [{
    //     desc: '1. 您可通过说“小白小白”唤醒后，和小白说“聊天模式”、“沉浸式聊天”、“指令模式”、“英语语伴”，切换不同的语音模式。'
    //   }, {
    //     desc: '2. 您可通过触摸小白的下巴，切换聊天模式和指令模式。'
    //   }, {
    //     desc: '3. 您可通过和小白说“退出”或触摸小白的后脑勺，退出语音交互。'
    //   }]
    // },
    video: {
      title: '如何进行视频通话',
      method: {
        list: [{
          info: {
            list: [{
              info: '小白如何发起视频通话'
            }]
          },
          list: [{
            desc: '您可以通过给到小白“打电话给爸爸”的指令，向 App 中宠物通讯录成员发起视频通话。',
            url: 'https://cdn.weilandog.com/app/image/instructionBook/video_step1_1_new.jpg'
          }]
        }, {
          info: {
            list: [{
              info: '小白如何接通和挂断 App 打来的视频通话'
            }]
          },
          list: [{
            desc: '1. 您可以通过给到小白“接电话”的指令，或者触摸小白下巴处的感应区接通来电。',
            url: 'https://cdn.weilandog.com/app/image/instructionBook/video_step2_1.jpg'
          }, {
            desc: '2. 您可以通过给到小白“挂电话”的指令，或者触摸小白后脑勺的感应区挂断来电。',
            url: 'https://cdn.weilandog.com/app/image/instructionBook/video_step2_2.jpg'
          }]
        }]
      }
    }
  },
  smallRangeActivity: {
    title: '如何开启小范围活动',
    concentrateList: ['1. 若小白尚未定位充电位置，小白会在开机位置2*4m范围内活动休息。', '2. 若您将小白带往全新的环境，开启小范围活动后，小白会在原点站立等待。']
  },
  autoBox: {
    rereceive: {
      name: '如何让小白进入 AutoBox',
      desc: '在激活40分钟后，您可以使用 AutoBox 收纳小白。请您按照如下步骤操作。',
      concentrate: '请务必在小白进入 AutoBox 趴好后关机，以防小白在箱内自主活动，造成人身伤害和财物损失。',
      list: [{
        info: '将 AutoBox 放置于小白前方1～2m范围内'
      }, {
        info: '等待小白识别 AutoBox，调整位置后自行走入并趴下'
      }, {
        info: '长按小白开关机键，听到“嘀”声后松手完成关机'
      }, {
        info: '盖上另一半箱体，即可完成收纳'
      }]
    },
    out: {
      name: '如何让小白走出 AutoBox',
      list: [{
        info: '请将小白在 AutoBox 内摆放为开机标准姿势（详见“图解开机前置条件”章节）'
      }, {
        info: '将在 AutoBox 内启动小白（详见“开机方法”章节）'
      }, {
        info: '小白会自行站起，并从 AutoBox 内走出，请不要人为干扰它'
      }]
    }
  },
  technicalSpecifications: {
    list: [
      {
        name: '重量',
        value: '8.5~8.8kg（不同型号间有所差异）'
      },
      {
        name: '正常站立（长宽高）',
        value: '572 x 298 x 525mm'
      },
      {
        name: '高姿站立（长宽高）',
        value: '550 x 298 x 555mm'
      },
      {
        name: '完全趴下（长宽高）',
        value: '625 x 333 x 328mm'
      },
      {
        name: '自由度',
        value: '12'
      },
      {
        name: '屏幕尺寸',
        value: '3.5英寸'
      },
      {
        name: '屏幕分辨率',
        value: '480*800'
      },
      {
        name: '内存',
        value: '8G'
      },
      {
        name: '闪存',
        value: '64G'
      },
      {
        name: '存储',
        value: '128G~1TB（不同型号间有所差异）'
      },
      {
        name: '蜂窝网络',
        value: '4G LTE Cat 4'
      },
      {
        name: 'Wi-Fi网络',
        value: 'Wi-Fi 5 IEEE 802.11 a/b/g/n/ac'
      },
      {
        name: '蓝牙',
        value: '蓝牙 5.0'
      },
      {
        name: '操作系统',
        value: 'Ubuntu 20.04 + ROS'
      },
      {
        name: '广角视觉',
        value: '2MP  FOV：120°'
      },
      {
        name: '主动红外视觉',
        value: '2MP FOV：90°'
      },
      {
        name: '麦克风阵列',
        value: '支持'
      },
      {
        name: '多点触摸感知',
        value: '支持'
      },
      {
        name: '温湿度感知',
        value: '支持'
      },
      {
        name: '六自由度惯性量感知',
        value: '支持'
      },
      {
        name: '关节力控感知',
        value: '支持'
      },
      {
        name: '运动探测雷达',
        value: 'Max 4m探测'
      },
      {
        name: '360° 激光雷达',
        value: 'Max 8m探测'
      },
      {
        name: '多 TOF 飞行时间雷达',
        value: '支持'
      },
      {
        name: '6D 空间状态感知',
        value: '支持'
      },
      {
        name: '综合续航 ',
        value: '70分钟~120分钟（不同型号间有所差异）'
      },
      {
        name: '最长待机时间 ',
        value: '约5~6小时（不同型号间有所差异）'
      },
      {
        name: '快充充电时间 ',
        value: '约90分钟'
      },
      {
        name: '最大前进速度 ',
        value: '2.0~4.8公里/小时（不同型号间有所差异）'
      },
      {
        name: '最大爬坡角度 20°',
        value: '20°'
      },
      {
        name: '运动中动态平衡',
        value: '支持'
      },
      {
        name: '倒地恢复',
        value: '支持'
      },
      {
        name: '摔倒保护',
        value: '支持'
      },
      {
        name: '平面位移感知',
        value: '支持'
      },
      {
        name: '快速充电',
        value: '支持'
      },
      {
        name: '指尖遥控器',
        value: '支持'
      },
      {
        name: '工作环境温度 ',
        value: '0 ~ 35°C'
      },
      {
        name: '存储环境温度',
        value: ' -10 ~ 45°C'
      },
      {
        name: '充电环境温度 ',
        value: '5°C ~ 30°C'
      }
    ]
  },
  securityLegal: {
    legalNotices: {
      list: [{
        info: '在使用机器狗之前，请您务必仔细阅读本说明书，按照说明书内容操作机器狗。 '
      }, {
        info: '机器狗仅限 14 周岁以上且具有相应认知和行为能力者人士单独使用（具体详见说明书的操控者要求说明一节）。'
      }, {
        info: '蔚蓝（南京蔚蓝智能科技有限公司及其关联公司）将不对违反说明书使用机器狗而造成的人身伤害、财产损失等事故承担责任。'
      }, {
        info: '用户的个人隐私等相关问题详见《蔚蓝机器狗隐私政策》《最终用户许可协议》等文件，敬请您仔细阅读。'
      }, {
        info: '本说明书所展示的机器狗旨在指导用户如何正确及更好的体验机器狗，展示图片/视频中的机器狗在颜色、外观等方面可能与您购买的机器狗有所区别，请您以实际收到的产品为准。 '
      }, {
        info: '为不断提升产品功能和您的使用体验，机器狗会不断升级优化，电子版使用说明书将同步在微信公众号、官网、App 中并不定期更新，您可及时获取最新版本。  '
      }, {
        info: '用户使用机器狗时应当遵守中华人民共和国法律法规，不得将机器狗用于伤害他人/动物，不得改装用作武器，否则或将使您丧失产品保修及其他客户权利。'
      }, {
        info: '您所购买的机器狗是基于中华人民共和国（大陆地区）法律和相关技术服务支持打造，我们建议您在中国大陆地区使用机器狗，以获得更好的使用体验和更完善的售后服务。'
      }, {
        info: '本声明适用中华人民共和国（大陆地区）法律。'
      }]
    },
    attention: {
      list: [{
        info: '为降低受伤风险，请务必在操控前检查小白的运行状态。'
      }, {
        info: '请在平坦的地面上启动小白，请勿突然急加速/减速，避免失控、碰撞风险。 '
      }, {
        info: '请在操控时保持警惕，使小白及小白活动的区域处于您的视线范围内，避免撞到他人或财物。'
      }, {
        info: '请以合适的速度操控小白，时刻注意与其他移动的人/物保持安全距离。驶入陌生环境时，请减速慢行。 '
      }, {
        info: '为避免分心，请勿在操控小白时佩戴耳机、耳塞、接打电话、拍照、摄像或做任何与操控小白无关的活动，以在操控时能很好地观察外部环境。'
      }, {
        info: '在视线不佳的环境操控小白时，应谨慎操作，避免人身和财产受损。  '
      }, {
        info: '请勿在冰面、玻璃面等光滑、易摔倒地面操控小白。'
      }, {
        info: '请勿在桌面、床等高处、狭小的环境下操控小白，避免掉落撞伤。'
      }, {
        info: '操控小白转弯时请减速，避免小白失控。'
      }, {
        info: '请勿在零部件发生损坏的情况下操控小白。'
      }, {
        info: '请勿人为干预小白的正常运行，避免人身伤害。'
      }, {
        info: '请勿骑乘小白，避免人身伤害或财物损坏。'
      }, {
        info: '请勿为小白负重，避免人身伤害或财物损坏。'
      }, {
        info: '请勿用力拉扯小白的耳朵、尾巴等柔软部位，避免小白跌倒，造成人身伤害或财物损坏。'
      }, {
        info: '请勿擅自改装或拆解小白。'
      }, {
        info: '请勿使用非原厂配件对小白进行部件替换、加装等操作。'
      }, {
        info: '请勿自行加装第三方部件，这可能导致兼容性和可靠性问题。'
      }, {
        info: '请避免小白遭遇浸入液体、进杂物、接触化学物质、划伤等事件，这将导致其损坏。'
      }, {
        info: '请勿用强力水流或高压软管清洗小白，避免电池、电路芯片等部件进水。'
      }, {
        info: '如您的小白已被淋雨或机身进水，请立即停止使用，切勿开机，及时联系售后服务人员。'
      }, {
        info: '请勿自行对小白进行擦干以外的操作，以免操作不当造成小白的进一步损坏或导致无法保修。 '
      }, {
        info: '请避免小白长时间不启动，这可能减损电池性能。'
      }, {
        info: '请勿擅自维修部件、改造电路和电池组、不当使用充电器。'
      }, {
        info: '请勿在矿区、发射塔、高压线、变电站、核辐射区域等电磁环境复杂或强干扰源环境下操控小白，避免无线设备/信号对小白的操控产生干扰。'
      }, {
        info: '请勿在室外使用Chat版本的机器狗。'
      }, {
        info: '本产品不支持用户使用第三方应用。'
      }, {
        info: '请勿使用任何非官方渠道系统及更新，这可能会带来安全风险。'
      }]
    },
    sportAttention: {
      list: [{
        info: '请勿在大风、雨、雪、沙尘、盐碱、高温、低温、泥泞等恶劣的环境、路况或场景下操控小白，避免损坏电池、电路或自燃、爆炸等情况发生。'
      }, {
        info: '建议在较为封闭且偏硬质的路面环境（如柏油路面、瓷砖路面、橡胶跑道等）使用。'
      }, {
        info: '请勿在公共交通道路上操控小白，避免交通事故或其他不利后果发生。'
      }, {
        info: '在通过有障碍物、突起处等路况复杂处或陌生环境时，请谨慎操控小白，降速慢行。'
      }, {
        info: '请勿在机动车辆、非机动车、行人、水坑、水域或其他障碍物附近操控小白。'
      }, {
        info: '当小白被操控接近或通过非公共交通道路上的交叉路口、转弯处、各种出入口等地时，请务必减速慢行，避让行人、动物及车辆，做好提前预判和防范工作。'
      }, {
        info: '通过不明遮盖物的地面时，请事先确认遮盖物下方地面虚实，确保小白安全通过。 '
      }]
    }
  },
  maintenance: {
    afterManipulation: {
      list: [{
        info: '请将小白停至较平整地面后再进行关机操作。'
      }, {
        info: '请勿将开机状态的小白放入 AutoBox，避免小白自主移动。 '
      }, {
        info: '请使用原装充电器充电，避免电池出现损坏或引发起火风险。 '
      }]
    },
    host: {
      list: [{
        info: '更换配件时，请使用原厂指定配件，以免不适配导致小白损坏。 '
      }, {
        info: '足底脚垫为消耗品，磨损严重、缺角、脱落等情形可能导致小白运动或站立不稳。'
      }, {
        info: '请定期清洁小白相机、传感器等部件表面灰尘。 '
      }, {
        info: '请定期检查电池电量与健康状况，当电池续航时间明显缩短时，请联系客服更换电池。'
      }, {
        info: '请在阴凉干燥处储存小白和电源适配器。 '
      }]
    },
    battery: {
      list: [{
        info: '切勿将电池存储在室温超过 45°C 或者低于 -10°C 的环境中。若长期闲置电池，将会对其性能造成影响。 '
      }, {
        info: '电池长时间储存时（3 个月以上），建议存贮在温度为 20℃～25℃，相对湿度为 0～60％RH 的环境中，电池的总电量不要超过 80％，以 30％～50％为佳。 '
      }, {
        info: '电池在存贮过程中，需要定期检查电池电量，如电池电量低于 20％时，需要再次对电池进行充电。建议至少每隔 3 个月左右重新充电一次以保持电池活性。 '
      }, {
        info: '电池的推荐充电温度为 10℃～25℃。 '
      }, {
        info: '电池充电时间请勿超过 24 小时，过度充电将缩短电池寿命。 '
      }, {
        info: '电池欠压保护后，将不能对外输出，必须充电后才能恢复正常。 '
      }, {
        info: '切勿将电池深度过放，避免电池永久失效，不能再进行充电。 '
      }, {
        info: '电池在充满时将自动停止充电。建议电池充满之后断开与充电设备的连接。 '
      }]
    }
  },
  question: {
    title: '常见问题和解决方案',
    list: [{
      title: '开机过程中，眼睛屏幕显示消失同时指示灯熄灭。',
      desc: '小白电量不足，进入低电保护状态，需使用直充充电器套装为小白充电，约1.5小时后即可正常使用。'
    }, {
      title: '如何知道小白已经开机成功？',
      desc: '小白开机过程中会伴随动画和语音提示，当小白眼睛屏幕的动画结束，出现表情的时候，就说明开机完成了。'
    }, {
      title: '按下小白背部的凸起，运行中的小白停止运行并快速趴下。',
      desc: '小白背部的凸起是急停按钮，紧急情况下按下，小白将立即停止并趴下，以确保安全。'
    }, {
      title: '可以牵绳子遛狗吗？',
      desc: '当前软件版本的机器狗小白不支持牵引绳控制模式。'
    }, {
      title: '原装的指尖遥控器坏掉了，我又买了一个，如何连接上小白？ ',
      desc: '新的指尖遥控器并未与小白建立绑定关系，第一次连接小白您需要操作指尖遥控器到配对状态，与小白建立连接才可以，具体操作方法，请参考本说明书中关于指尖遥控器第一次使用配对的方法章节。'
    }, {
      title: '指尖遥控器遥控小白的时候，小白走得很慢，我想让它走得快些。',
      desc: '指尖遥控器设计了高速模式与低速模式，默认采用低速模式。如果想具有更快的速度，可以通过按下速度切换按键来切换遥控速度，速度提高后，请缓慢适应，请勿大幅推拉手柄，以免发生碰撞。'
    }, {
      title: '指尖遥控器最开始控制小白是好用的，但是有时候控制失效，过一会又会恢复。',
      desc: '指尖遥控器有效控制范围在5m内，空旷区域控制范围可达10m，若附近有人在移动或者有金属障碍物，会严重影响信号传输，遥控器会出现断线的情况。当指尖遥控器与小白的距离满足最小通讯范围后，指尖遥控器自动回连到小白，恢复通讯。所以建议在10m以内空旷环境使用。'
    }, {
      title: '小白不能避障了，一些障碍物检测不到，甚至会撞坏自己或者其他物体。',
      descList: [{
        desc: '1、首先，请观察是否存在下巴传感器被遮挡，背部激光雷达被遮挡，头部激光雷达被遮挡的情况。如有遮挡，请移除遮挡。'
      }, {
        desc: '2、如果在人为手柄遥控，或者 App 遥控的情况下，用户控制的优先级要高于避障等辅助功能的优先级，自主避障功能关闭，小白在人为遥控下可能会出现碰撞等情况。'
      }, {
        desc: '3、小白依托于视觉、探测雷达、TOF 等多传感器融合来对障碍物进行识别和避障。小白很难识别特别细小或者透明的障碍物，可能会存在无法避障的情况。'
      }]
    }, {
      title: '我可以通过语音的形式唤醒小白，但是小白只是回答了“我在”，不会语音回复我，和我讲话。',
      descList: [{
        desc: '1、检测是否是网络信号不好，小白依托于蜂窝网络和 Wi-Fi 通讯，如果当前所处位置网络不好，小白会存在语音交互卡顿，或者语音交互停止的情况。'
      }, {
        desc: '2、请确定小白使用的是否是专属 Wi-Fi 网络，因为部分专属 Wi-Fi 网络存在防火墙，防火墙可能会阻止小白的语音交互能力。'
      }]
    }]
  },
  help: {
    weChatQRCode: {
      desc: '蔚蓝微信公众号，扫码获取帮助',
      url: 'https://cdn.weilandog.com/app/image/instructionBook/we_chat_QRCode.jpg'
    }
  }
}
export default cn



// WEBPACK FOOTER //
// ./src/i18n/langs/cn.js